import * as v2 from '../v2';
import {Extendom} from 'extendom';
// import {CodeGenerator} from 'extendom/codegen';
import './xd_reply';

class Reply {
  body = '';
  readonly uploader = new v2.Uploader(25);
  onChangeBody(_event: Event, {element}: {element: HTMLTextAreaElement}) {
    this.body = element.value;
  }
  appendToFormData(body: FormData) {
    body.append('json', JSON.stringify({reply: this.asJSON()}));
    this.uploader.appendToFormData(body, 'reply[files][]');
  }
  asJSON() {
    return {
      body: this.body,
    };
  }
}

export class ReplyPage extends v2.PostFormPage {
  readonly xd;
  readonly reply = new Reply;
  constructor() {
    super();
    const spec = document.querySelector('#spec') as HTMLElement;
    // CodeGenerator.generateTypeScriptCode(spec, 'ReplyPage', {dialog: true});
    this.xd = new Extendom(spec, this, document.querySelector('#root')!);
  }
  override async onClickPreview(event: Event, {data}: {data: unknown}) {
    if (!await super.onClickPreview(event, {data}))
      return;
    document.documentElement.scrollTop = document.documentElement.scrollHeight;
    return data;
  }
  protected validate = () => {
  };
  protected appendToFormData = (body: FormData) => {
    this.reply.appendToFormData(body);
  };
}

window.addEventListener('DOMContentLoaded', () => {
  const pattern = /^\/.+\/messages\/\d+$/;
  if (pattern.test(location.pathname) && document.querySelector('#spec'))
    new ReplyPage;
});
